module.exports = "assets/615f16f5528a973d401d8456a964b23f.glb";